import { ObjectGraph } from '@jet/environment/dependencies';
import type { Intent } from '@jet/environment/dispatching';
import type { Optional } from '@jet/environment/types/optional';
import {
    type FlowAction,
    type FlowActionDestination,
    makeFlowAction,
} from '@jet-app/music-classical/models/actions';
import type { ActionProvider, ActionProviderOptions } from './action-provider';

export class DefaultActionProvider implements ActionProvider<Intent<unknown>> {
    $intentKind = 'unknown';

    // TODO Surely, this is incomplete.
    actionFor(
        intent: Intent<unknown>,
        _objectGraph: ObjectGraph,
        options: ActionProviderOptions,
    ): Optional<FlowAction> {
        return makeFlowAction(intent as FlowActionDestination, options.metrics);
    }
}
